import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MoneyDisplay from '../../../../components/money-display';
import DateTimeDisplay from '../../../../components/date-time-display';
import NumberDisplay from '../../../../components/number-display';
import ProgressBar from '../../../../components/progress-bar';
import styles from './styles.css';

class LogPopover extends Component {
  getTitle() {
    const { type } = this.props;
    let t = '';
    switch (type) {
      case 'amount':
        t = 'Amount History';
        break;
      case 'close_date':
        t = 'Close Date History';
        break;
      case 'stage_name':
        t = 'Stage History';
        break;
      case 'forecast_category_name':
        t = 'Forecast Category History';
        break;
      default:
        t = '';
    }
    return t;
  }
  getDisplayComp() {
    const { type } = this.props;
    let c = null;
    switch (type) {
      case 'amount':
        c = MoneyDisplay;
        break;
      case 'close_date':
        c = DateTimeDisplay;
        break;
      default:
        c = null;
    }
    return c;
  }
  renderTable() {
    const { logs, total, noWrapper } = this.props;
    const Comp = this.getDisplayComp();
    if (total === 0) {
      return (<div><small>No records found.</small></div>);
    }
    const hasMore = logs.length < total;
    return (
      <table className={`table table-condense ${noWrapper ? 'table-striped' : ''} ${styles.tableLogs}`}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Changed from</th>
            <th>Changed to</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, idx) => {
            const n = Comp ? (<Comp value={log.new_value} format="short" precision={1} abbreviated />) : log.new_value;
            let o = Comp ? (<Comp value={log.old_value} format="short" precision={1} abbreviated />) : log.old_value;
            if (idx === 0 && log.old_value === null) {
              o = (<div className="text-center"> - </div>);
            }
            return (
              <tr key={idx}>
                <td><nobr><DateTimeDisplay value={log.date} format="short" /></nobr></td>
                <td>{o}</td>
                <td>{n}</td>
              </tr>
            );
          })}
          {hasMore &&
            <tr>
              <td colSpan="3">
                <div className="text-center">
                  <em>click to view all <NumberDisplay precision={0} value={total} suffixIsUnit suffix="change" /></em>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    );
  }
  render() {
    const {
      loaded, enter, className, style,
      noWrapper,
    } = this.props;
    const comp = enter ? (
      <div>
        {!noWrapper && <h3>{this.getTitle()}</h3>}
        {loaded && this.renderTable()}
        {!loaded && (<div style={{ padding: 10 }}><ProgressBar /></div>)}
      </div>
    ) : null;

    if (noWrapper) {
      return comp;
    }
    return (
      <div className={`${className} ${styles.popover}`} style={style}>
        <div className={styles.popoverInner}>
          {comp}
          {!enter && <div>&nbsp;</div>}
        </div>
      </div>
    );
  }
}


LogPopover.propTypes = {
  type: PropTypes.string.isRequired,
  loaded: PropTypes.bool.isRequired,
  enter: PropTypes.bool.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  logs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number,
  noWrapper: PropTypes.bool,
};

LogPopover.defaultProps = {
  className: null,
  total: 0,
  style: {},
  noWrapper: false,
};

export default LogPopover;